// extracted by mini-css-extract-plugin
export var border = "_b2-b";
export var circle = "_b2-4";
export var circleInner = "_b2-5";
export var disabled = "_b2-1";
export var focused = "_b2-a";
export var md = "_b2-8";
export var radioButton = "_b2-0";
export var radioInput = "_b2-2";
export var selected = "_b2-9";
export var sm = "_b2-7";
export var text = "_b2-3";
export var xs = "_b2-6";